module.exports = __webpack_public_path__ + "static/media/PB-RACE-BLUE-WIDE-1.d19c0eb0.svg";